import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import ComputedPriceField from 'components/field/ComputedPriceField';
import CSVFields, { mandatoryFields } from 'pages/invoices/export/settings';
import DateField from 'components/field/DateFields/DateField';
import DownloadCSV from 'components/export/DownloadCSV';
import Header from 'components/ui/general/Header';
import InvoicesListFilters from 'pages/invoices/list/InvoicesListFilters';
import InvoiceStatus from 'pages/invoices/show/InvoiceStatus';
import listQueryFilter from 'components/hoc/listQueryFilter';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import UserField from 'components/field/UserField';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { exportInvoices, exportInvoicesLines } from 'store/actions/invoices/exportInvoices';
import { fetchInvoices } from 'store/actions/invoices/fetchInvoices';
import theme from 'theme/theme';
import TextField from 'components/field/TextField';

const InvoicesListContainer = (props) => {
    const {
        actionType,
        exportAction,
        exportLinesAction,
        location,
        resource,
        updateQuery,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.invoices.title') } />

                <Actions>
                    <DownloadCSV
                        base='created_at'
                        csvFields={ CSVFields }
                        exportAction={ exportAction }
                        label={ translate('resources.invoices.export.title') }
                        mandatoryFields={ mandatoryFields }
                        resource={ resource }
                    />
                    <DownloadCSV
                        base='created_at'
                        csvFields={ () => {} }
                        exportAction={ exportLinesAction }
                        label={ translate('resources.invoices.export.lines.title') }
                        resource={ resource }
                    />
                </Actions>
            </Header>

            <InvoicesListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchInvoices }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    backgroundToggle={ {
                        condition: true,
                        color: theme.palette.colonialWhite,
                        key: 'suspicious',
                    } }
                >
                    <TextField
                        column={ {
                            sortable: true,
                            width: '15%',
                        } }
                        label='resources.products.fields.id'
                        source='id'
                    />

                    <DateField
                        column={ {
                            sortable: false,
                            width: '25%',
                        } }
                        label='resources.invoices.fields.invoiced_at'
                        options={ {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        } }
                        source='invoiced_at'
                    />

                    <UserField
                        backgroundColor='rgba(0,0,0,0)'
                        column={ {
                            sortable: false,
                            width: '30%',
                        } }
                        label='resources.users.name'
                        source='user_id'
                        style={ { margin: '-6px' } }
                    />

                    <InvoiceStatus
                        column={ {
                            sortable: false,
                            width: '15%',
                        } }
                        label='resources.invoices.fields.status'
                        source='status'
                    />

                    <ComputedPriceField
                        column={ {
                            sortable: false,
                            width: '10%',
                        } }
                        label='resources.invoices.fields.amount'
                        source='amount'
                    />
                </Table>
            </ResourceList>
        </div>
    );
};

InvoicesListContainer.propTypes = {
    actionType: PropTypes.string.isRequired,
    exportAction: PropTypes.func.isRequired,
    exportLinesAction: PropTypes.func.isRequired,
    location: PropTypes.any,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func,
    translate: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        filter: state.invoices.filter,
        total: state.invoices.total,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        exportAction: (payload) => {
            dispatch(exportInvoices(payload));
        },
        exportLinesAction: (payload) => {
            dispatch(exportInvoicesLines(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    listQueryFilter,
    translate,
);

export default enhance(InvoicesListContainer);


// WEBPACK FOOTER //
// ./src/pages/invoices/list/InvoicesListContainer.js